import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Chip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { fetchData } from "../../BaseUrl";
import DynamicTable from "../../DynamicComponent/DynamicTable";

const fallbackStudents = [
  { regNo: "REG001", studentName: "Aarav Kumar", grade: "Grade 3", section: "A", parentName: "Rajesh Kumar", parentPhone: "9876543210", statusChip: "Active", emergencyContactName: "Priya Kumar", emergencyContactPhone: "9876500001", skippedGrade: false },
  { regNo: "REG002", studentName: "Priya Sharma", grade: "Grade 3", section: "B", parentName: "Suresh Sharma", parentPhone: "9876543211", statusChip: "Active", emergencyContactName: "Anita Sharma", emergencyContactPhone: "9876500002", skippedGrade: true },
  { regNo: "REG003", studentName: "Karthik Raj", grade: "Grade 4", section: "A", parentName: "Mani Raj", parentPhone: "9876543212", statusChip: "In Active", emergencyContactName: null, emergencyContactPhone: null, skippedGrade: false },
  { regNo: "REG004", studentName: "Divya Nair", grade: "Grade 4", section: "C", parentName: "Vijay Nair", parentPhone: "9876543213", statusChip: "Active", emergencyContactName: "Meena Nair", emergencyContactPhone: "9876500004", skippedGrade: false },
  { regNo: "REG005", studentName: "Sanjay Patel", grade: "Grade 5", section: "A", parentName: "Ramesh Patel", parentPhone: "9876543214", statusChip: "Active", emergencyContactName: null, emergencyContactPhone: null, skippedGrade: true },
];

const actionBtnStyle = {
  border: "1px solid #D5D7DA",
  borderRadius: "8px",
  color: "#8F95B2",
  textTransform: "none",
  fontSize: "13px",
  padding: "6px 14px",
};

export default function StudentList() {
  const [rows, setRows] = useState([]);

  const buildRows = useCallback((data) => {
    return data.map((s) => {
      const skipped = s.skippedGrade;
      return {
        regNo: s.regNo || s.applicationId || s.reg_no,
        studentName: s.studentName || s.name,
        grade: s.grade,
        section: s.section,
        parentName: s.parentName || s.parent_name,
        parentPhone: s.parentPhone || s.parent_phone || s.parentPh,
        emergencyName: s.emergencyContactName || "—",
        emergencyPhone: s.emergencyContactPhone || "—",
        skippedGrade: (
          <Chip
            label={skipped ? "Yes" : "No"}
            size="small"
            sx={{
              backgroundColor: skipped ? "#e8f5e9" : "#f3f4f6",
              color: skipped ? "#4caf50" : "#6B7280",
              fontWeight: "bold",
              fontSize: "12px",
              borderRadius: "20px",
            }}
          />
        ),
        statusChip: (
          <Chip
            label={s.status || s.statusChip || "Active"}
            size="small"
            sx={{
              backgroundColor: (s.status || s.statusChip || "Active") === "Active" ? "#e8f5e9" : "#ffebee",
              color: (s.status || s.statusChip || "Active") === "Active" ? "#4caf50" : "#f44336",
              fontWeight: "bold",
              fontSize: "12px",
              borderRadius: "20px",
              padding: "4px 12px",
            }}
          />
        ),
      };
    });
  }, []);

  const loadStudents = useCallback(async () => {
    try {
      const response = await fetchData("teacher/students/list");
      if (response?.data && Array.isArray(response.data)) {
        setRows(buildRows(response.data));
      } else {
        setRows(buildRows(fallbackStudents));
      }
    } catch (_) {
      setRows(buildRows(fallbackStudents));
    }
  }, [buildRows]);

  useEffect(() => {
    loadStudents();
  }, [loadStudents]);

  const columns = [
    { label: "Reg No", field: "regNo" },
    { label: "Student Name", field: "studentName" },
    { label: "Grade", field: "grade" },
    { label: "Section", field: "section" },
    { label: "Parent Name", field: "parentName" },
    { label: "Parent Ph.no", field: "parentPhone" },
    { label: "Emergency Name", field: "emergencyName" },
    { label: "Emergency Ph.no", field: "emergencyPhone" },
    { label: "Skipped Grade", field: "skippedGrade" },
    { label: "Status", field: "statusChip" },
  ];

  return (
    <Box sx={{ padding: "1rem", textAlign: "left" }}>
      <p style={{ color: "rgba(0,0,0,0.5)", fontWeight: "bold", fontSize: "14px", margin: 0 }}>
        Pages / Student List
      </p>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1, mb: 2, flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <h2 style={{ margin: 0 }}>Student List</h2>
          <Chip
            label="105 Students"
            size="small"
            sx={{ backgroundColor: "#e8f5e9", color: "#4caf50", fontWeight: "bold", fontSize: "12px", borderRadius: "20px", padding: "4px 12px" }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Button startIcon={<DeleteOutlineIcon />} sx={actionBtnStyle}>Delete</Button>
          <Button startIcon={<FilterListIcon />} sx={actionBtnStyle}>Filters</Button>
          <Button startIcon={<FileDownloadIcon />} sx={actionBtnStyle}>Export</Button>
        </Box>
      </Box>
      <DynamicTable columns={columns} rows={rows} />
    </Box>
  );
}
